import { defaultAdultAge } from "@/helpers/defaultAdultAge.ts";
import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { PersonType } from "@/helpers/types/types.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { v4 as uuid } from "uuid";

export const createCAItem = (
  ratePlan: RatePlanMerged,
  adults: number,
  dateRange: [Date | null, Date | null],
): CartAccommodationItem => ({
  id: uuid(),
  rateGroup: ratePlan.rateGroup,
  mandatoryExtras: [],
  adults: Array.from({ length: adults }, () => ({
    id: uuid(),
    age: defaultAdultAge,
    type: PersonType.Adult,
  })),
  children: [],
  optionalExtras: [],
  dateRange,
  ratePlan,
});
